import { BOOKING_STATUS } from 'constants/index';

const {
  GET_BOOKING_LIST,
  GET_BOOKING_LIST_FAILED,
  GET_BOOKING_LIST_SUCCESS,

  GET_BOOKING_DETAIL,
  GET_BOOKING_DETAIL_FAILED,
  GET_BOOKING_DETAIL_SUCCESS,

  APPROVE_BOOKING,
  APPROVE_BOOKING_SUCCESS,
  APPROVE_BOOKING_FAILED,

  REJECT_BOOKING,
  REJECT_BOOKING_SUCCESS,
  REJECT_BOOKING_FAILED,
  EXPORT_BOOKING_LIST_SUCCESS,
  EXPORT_BOOKING_LIST,
  EXPORT_BOOKING_LIST_FAILED,

  REFUND_BOOKING,
  REFUND_BOOKING_SUCCESS,
  REFUND_BOOKING_FAILED,

  CONFIRM_BOOKING,
  CONFIRM_BOOKING_SUCCESS,
  CONFIRM_BOOKING_FAILED,

  OTA_SYNC_BOOKING,
  OTA_SYNC_BOOKING_SUCCESS,
  OTA_SYNC_BOOKING_FAILED,
} = require('./actionTypes');

const DEFAULT_BOOKING_DETAIL = {
  _id: '',
  orderId: '',
  userInfo: {
    fullName: '',
    email: '',
    phoneNumber: '',
    _id: '',
    displayName: '',
    country: '',
    province: '',
    district: '',
    address: '',
  },
  placeInfo: {
    name: '',
    placeType: '',
    province: '',
    district: '',
    ward: '',
    address: '',
    starRating: 0,
    previewImage: '',
    location: {
      type: '',
      coordinates: [
        0,
        0,
      ],
    },
    allowSmoking: false,
    allowPet: false,
  },
  startedAt: '0-0-0T0:0:0Z',
  endedAt: '0-0-0T0:0:0Z',
  adults: 0,
  children: 0,
  cancelBookingPolicy: {
    freeBeforeDays: 1,
    cancelPenalty: '',
  },
  depositPolicy: {
    allowDeposit: false,
    amount: 0,
  },
  checkInTime: {
    from: '00:00',
    to: '00:00',
  },
  checkOutTime: {
    from: '00:00',
    to: '00:00',
  },
  totalPrice: 0,
  rooms: [
    {
      room: '',
      clientName: '',
      roomName: '',
      bedTypes: [
        {
          bedType: '',
          quantity: 0,
          _id: '',
        },
      ],
      size: 0,
      roomQuantity: 0,
      roomFacilities: [
        {
          facilityGroup: '',
          facility: '',
          _id: '',
        },
      ],
      maxAdults: 0,
      maxChildren: 0,
      roomPriceType: {
        priceType: '',
        name: '',
        cancelBookingPolicy: {
          freeBeforeDays: 0,
          cancelPenalty: '',
        },
        includeMeals: [
          '',
        ],
      },
      roomPrice: 0,
      _id: '',
    },
  ],
  tripPurpose: '',
  estimatedCheckInAt: '00:00 - 00:00',
  note: '',
  paymentType: '',
  bookingStatus: '',
  isGetInvoice: false,
  invoiceInfo: null,
  cancelReasons: [],
  createdAt: '0-0-0T0:0:0Z',
  updatedAt: '0-0-0T0:0:0Z',
};

const initialState = {
  loadingBookingList: true,
  loadingBookingDetail: true,
  isLoadingApproveBooking: false,
  isLoadingConfirmBooking: false,
  isLoadingCancelBooking: false,
  isLoadingExportBookingList: false,
  isLoadingRefundBooking: false,
  isLoadingOtaSyncBooking: false,

  bookingList: [],
  bookingTotal: 0,
  bookingDetail: DEFAULT_BOOKING_DETAIL,
};

const booking = (state = initialState, action) => {
  switch (action.type) {
    // GET BOOKING LIST
    case GET_BOOKING_LIST:
      return {
        ...state,
        loadingBookingList: true,
      };

    case GET_BOOKING_LIST_SUCCESS:
      return {
        ...state,
        bookingList: action.payload.data,
        bookingTotal: action.payload.total,
        loadingBookingList: false,
      };

    case GET_BOOKING_LIST_FAILED:
      return {
        ...state,
        loadingBookingList: false,
      };

      // EXPORT BOOKING LIST
    case EXPORT_BOOKING_LIST:
      return {
        ...state,
        isLoadingExportBookingList: true,
      };

    case EXPORT_BOOKING_LIST_SUCCESS:
      return {
        ...state,
        isLoadingExportBookingList: false,
      };

    case EXPORT_BOOKING_LIST_FAILED:
      return {
        ...state,
        isLoadingExportBookingList: false,
      };

    // GET BOOKING DETAIL
    case GET_BOOKING_DETAIL:
      return {
        ...state,
        loadingBookingDetail: true,
      };

    case GET_BOOKING_DETAIL_SUCCESS:
      return {
        ...state,
        bookingDetail: action.payload,
        loadingBookingDetail: false,
      };

    case GET_BOOKING_DETAIL_FAILED:
      return {
        ...state,
        loadingBookingDetail: false,
      };

    // APPROVE BOOKING
    case APPROVE_BOOKING:
      return {
        ...state,
        isLoadingApproveBooking: true,
      };

    case APPROVE_BOOKING_SUCCESS:
      return {
        ...state,
        isLoadingApproveBooking: false,
        bookingDetail: {
          ...state.bookingDetail,
          bookingStatus: BOOKING_STATUS.APPROVED.key,
        },
      };

    case APPROVE_BOOKING_FAILED:
      return {
        ...state,
        isLoadingApproveBooking: false,
      };

    // REJECT BOOKING
    case REJECT_BOOKING:
      return {
        ...state,
        isLoadingCancelBooking: true,
      };

    // A paid booking ends REFUNDED or WAITING_FOR_REFUND instead, so the status comes from the
    // answer when there is one (WP-ADM-CANCEL-REFUND); the page refetches right after either way.
    case REJECT_BOOKING_SUCCESS:
      return {
        ...state,
        isLoadingCancelBooking: false,
        bookingDetail: {
          ...state.bookingDetail,
          ...action.payload,
          bookingStatus: action.payload?.bookingStatus || BOOKING_STATUS.CANCELLED_BY_PLACE.key,
        },
      };

    case REJECT_BOOKING_FAILED:
      return {
        ...state,
        isLoadingCancelBooking: false,
      };

    // REFUND BOOKING
    case REFUND_BOOKING:
      return {
        ...state,
        isLoadingRefundBooking: true,
      };

    case REFUND_BOOKING_SUCCESS:
      return {
        ...state,
        isLoadingRefundBooking: false,
        bookingDetail: {
          ...state.bookingDetail,
          bookingStatus: 'REFUNDED',
        },
      };

    case REFUND_BOOKING_FAILED:
      return {
        ...state,
        isLoadingRefundBooking: false,
      };

    // CONFIRM BOOKING
    case CONFIRM_BOOKING:
      return {
        ...state,
        isLoadingConfirmBooking: true,
      };

    case CONFIRM_BOOKING_SUCCESS:
      return {
        ...state,
        isLoadingConfirmBooking: false,
        bookingDetail: {
          ...state.bookingDetail,
          ...(action.payload || {}),
        },
        bookingList: state.bookingList.map((item) => {
          if (item._id === action.bookingId || item._id === action.payload?._id) {
            return {
              ...item,
              confirmBooking:
                action.confirmBooking !== undefined
                  ? action.confirmBooking
                  : action.payload?.confirmBooking || item.confirmBooking,
              ...(action.payload || {}),
            };
          }
          return item;
        }),
      };

    case CONFIRM_BOOKING_FAILED:
      return {
        ...state,
        isLoadingConfirmBooking: false,
      };

    // OTA SYNC (Hotellink re-push): the endpoint answers only { _id, orderId, otaSync }, never
    // otaBookingId, so the page refetches the full detail on success instead of this reducer
    // merging a partial otaSync in (docs/hotellink/booking-sync.md §4.3).
    case OTA_SYNC_BOOKING:
      return {
        ...state,
        isLoadingOtaSyncBooking: true,
      };

    case OTA_SYNC_BOOKING_SUCCESS:
    case OTA_SYNC_BOOKING_FAILED:
      return {
        ...state,
        isLoadingOtaSyncBooking: false,
      };

    default:
      return state;
  }
};

export default booking;
